var fetchUser;

fetchUser = {

  /*
   * Fetch user data from endpoint
   *
   * @param {String}   userId  - User snickerdoodle id
   * @param {Function} success - Success callback
   * @param {Function} [error] - Error callback (Optional)
   */
  fetch: function(userId, success, error) {
    var attributes, ref;
    userId = userId != null ? userId.replace(/"/g, '') : void 0;
    attributes = {
      service: 'user',
      userId: userId,
      country: document.head.getAttribute('data-country')
    };
    $.ajax({
      type: 'GET',
      url: ((ref = Groupon.endpoints) != null ? ref.user : void 0) || '/layout/calls/user',
      timeout: 5000,
      data: attributes,
      success: function(res) {
        var err, user;
        user = res.data, err = res.err;
        if (err) {
          return error(err);
        }
        if (!user) {
          return;
        }
        try {
          if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
            sessionStorage.setItem('verifiedUser', JSON.stringify(user));
          }
        } catch (error1) {}
        return success(user);
      },
      error: error
    });
  },

  /*
   * Removes user data from browser sessionStorage
   */
  removeUserData: function() {
    try {
      if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
        sessionStorage.removeItem('verifiedUser');
      }
    } catch (error1) {}
  },

  /*
   * @typedef  {Object}  userObject
   * @property {Boolean} hasUserData - Flag indicating that user data is stored
   * @property {String}  userId      - Snickerdoodle id
   */

  /*
   * Check for user data from Browser sessionStorage and process data if available
   *
   * @param   {Function} [noUser_cb]    - Callback executed when user is logged out (Optional)
   * @param   {Function} [hasUser_cb]   - Callback executed when user is logged in (Optional)
   * @returns {Object}   userObject
   */
  useStoredData: function(noUser_cb, hasUser_cb) {
    var data, hasUserData, ref, user, userId;
    userId = (ref = Cookie.get('snickerdoodle')) != null ? ref.replace(/"/g, '') : void 0;
    hasUserData = false;
    if (!userId) {
      this.removeUserData();
      if (noUser_cb) {
        noUser_cb();
      }
    } else {
      if ((data = typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.getItem('verifiedUser') : void 0) != null) {
        try {
          user = JSON.parse(data);
        } catch (error1) {}
        if (user && typeof user === 'object') {
          if (hasUser_cb) {
            hasUser_cb(user);
          }
          hasUserData = true;
        }
      }
    }
    return {
      hasUserData: hasUserData,
      userId: userId
    };
  }
};

module.exports = {
  fetchUser: fetchUser
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvdXNlci9mZXRjaFVzZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvdXNlci9mZXRjaFVzZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsU0FBQSxHQUNFOztBQUFBOzs7Ozs7O0VBT0EsS0FBQSxFQUFPLFNBQUMsTUFBRCxFQUFTLE9BQVQsRUFBa0IsS0FBbEI7QUFDTCxRQUFBO0lBQUEsTUFBQSxvQkFBUyxNQUFNLENBQUUsT0FBUixDQUFnQixJQUFoQixFQUFzQixFQUF0QjtJQUNULFVBQUEsR0FBYTtNQUNYLE9BQUEsRUFBUyxNQURFO01BRVgsTUFBQSxFQUFRLE1BRkc7TUFHWCxPQUFBLEVBQVMsUUFBUSxDQUFDLElBQUksQ0FBQyxZQUFkLENBQTJCLGNBQTNCLENBSEU7O0lBTWIsQ0FBQyxDQUFDLElBQUYsQ0FBTztNQUNMLElBQUEsRUFBTSxLQUREO01BRUwsR0FBQSwwQ0FBc0IsQ0FBRSxjQUFuQixJQUEyQixvQkFGM0I7TUFHTCxPQUFBLEVBQVMsSUFISjtNQUlMLElBQUEsRUFBTSxVQUpEO01BS0wsT0FBQSxFQUFTLFNBQUMsR0FBRDtBQUNQLFlBQUE7UUFBTyxXQUFOLElBQUQsRUFBYTtRQUNiLElBQXFCLEdBQXJCO0FBQUEsaUJBQU8sS0FBQSxDQUFNLEdBQU4sRUFBUDs7UUFDQSxJQUFVLENBQUksSUFBZDtBQUFBLGlCQUFBOztBQUNBOztZQUNFLGNBQWMsQ0FBRSxPQUFoQixDQUF3QixjQUF4QixFQUF3QyxJQUFJLENBQUMsU0FBTCxDQUFlLElBQWYsQ0FBeEM7V0FERjtTQUFBO2VBRUEsT0FBQSxDQUFRLElBQVI7TUFOTyxDQUxKO01BWUwsS0FBQSxFQUFPLEtBWkY7S0FBUDtFQVJLLENBUFA7O0FBK0JBOzs7RUFHQSxjQUFBLEVBQWdCLFNBQUE7QUFDZDs7UUFDRSxjQUFjLENBQUUsVUFBaEIsQ0FBMkIsY0FBM0I7T0FERjtLQUFBO0VBRGMsQ0FsQ2hCOztBQXVDQTs7Ozs7O0FBTUE7Ozs7Ozs7RUFPQSxhQUFBLEVBQWUsU0FBQyxTQUFELEVBQVksVUFBWjtBQUNiLFFBQUE7SUFBQSxNQUFBLG9EQUFvQyxDQUFFLE9BQTdCLENBQXFDLElBQXJDLEVBQTJDLEVBQTNDO0lBQ1QsV0FBQSxHQUFjO0lBSWQsSUFBRyxDQUFJLE1BQVA7TUFDRSxJQUFDLENBQUEsY0FBRCxDQUFBO01BQ0EsSUFBZSxTQUFmO1FBQUEsU0FBQSxDQUFBLEVBQUE7T0FGRjtLQUFBLE1BQUE7TUFJRSxJQUFHLG1JQUFIO0FBQ0U7VUFDRSxJQUFBLEdBQU8sSUFBSSxDQUFDLEtBQUwsQ0FBVyxJQUFYLEVBRFQ7U0FBQTtRQUdBLElBQUcsSUFBQSxJQUFTLE9BQU8sSUFBUCxLQUFlLFFBQTNCO1VBQ0UsSUFBb0IsVUFBcEI7WUFBQSxVQUFBLENBQVcsSUFBWCxFQUFBOztVQUNBLFdBQUEsR0FBYyxLQUZoQjtTQUpGO09BSkY7O0FBWUEsV0FBTztNQUNMLGFBQUEsV0FESztNQUVMLFFBQUEsTUFGSzs7RUFsQk0sQ0FwRGY7OztBQTJFRixNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNmLFdBQUEsU0FEZSJ9
